import { DropdownMenuItemType } from '@pancakeswap/uikit'
import type { ConfigMenuItemsType } from 'components/Menu/config/config'
import { openPwaSheet } from './events'

/** Stable ids of the More entries (not routes: they act). Distinct from every page path, so never "active". */
export const PWA_MENU_HREF = { install: '#install-app' } as const

/** "Install app" opens its sheet. Alerts are not here (Bez 2026-10-07): their switch is in Settings and on the profile. */
export const pwaMoreItems = (t: (key: string) => string) => [
  { label: t('Install app'), href: PWA_MENU_HREF.install, type: DropdownMenuItemType.BUTTON, onClick: () => openPwaSheet('install') },
]

/** "Install app" is pointless inside the installed app: drop it there. */
export function withoutInstallWhenStandalone(items: ConfigMenuItemsType[], standalone: boolean): ConfigMenuItemsType[] {
  if (!standalone) return items
  return items.map((item) => (item.items?.some((i) => i.href === PWA_MENU_HREF.install) ? { ...item, items: item.items.filter((i) => i.href !== PWA_MENU_HREF.install) } : item))
}
